/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespTradeOnApprovalCoachmarkLoader_item = {
    readonly serviceId: string | null;
    readonly " $refType": "PdpRespTradeOnApprovalCoachmarkLoader_item";
};
export type PdpRespTradeOnApprovalCoachmarkLoader_item$data = PdpRespTradeOnApprovalCoachmarkLoader_item;
export type PdpRespTradeOnApprovalCoachmarkLoader_item$key = {
    readonly " $data"?: PdpRespTradeOnApprovalCoachmarkLoader_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespTradeOnApprovalCoachmarkLoader_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespTradeOnApprovalCoachmarkLoader_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '0d7fad06a94145eca46080caf0dc776d';
export default node;
